export const blockIconsActionVerified = (
	<span className='material-symbols-outlined'>verified</span>
);
